import { getCurrentDate } from './getCurrentDate';
export function getStartOfYear() {
    var now = getCurrentDate();
    return new Date(now.getFullYear(), 0, 0, 0, 0, 0, 0);
}
//# sourceMappingURL=getStartOfYear.js.map